(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.headerSearch = {
    attach: function (context, settings) {
      once('headerSearch', '.main-header .search', context).forEach(function (block) {
        var container = $(block);
        container.find('.toggle-search').on('click', function(){
          container.find('[type="search"]').focus();
          container.find('.search-block').toggleClass('is-open');
        })
      })
    }
  }
})(jQuery, Drupal, once, drupalSettings);
